@if (
  {
    onStepNext: onStepNext$ | async,
    onStepPrevious: onStepPrevious$ | async
  };
  as STATE
) {
  <main class="signup-stepper">
    <mat-stepper
      #stepper
      (selectionChange)="emitStepChange($event)"
      linear
      animationDuration="0"
      [selectedIndex]="0"
    >
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        {{ index + 1 }}
      </ng-template>

      <mat-step [state]="states[0]">
        <company-identification-form></company-identification-form>
      </mat-step>

      <mat-step [state]="states[1]">
        <personal-infos-form></personal-infos-form>
      </mat-step>

      <mat-step [state]="states[2]">
        <email-confirmation-form></email-confirmation-form>
      </mat-step>
    </mat-stepper>
  </main>
}
